import { FC } from 'react';

import { Typography } from '../../../designComponents';
import { TaskCardStyled } from './style';

interface TaskCardPropsType {
  label: string;
  description: {
    label: string;
    desc: string;
  };
  tasks: {
    label: string;
    task1: string;
    task2: string;
    task3: string;
  };
}

const TaskCard: FC<TaskCardPropsType> = ({ label, description, tasks }) => {
  return (
    <TaskCardStyled>
      <Typography fontColor="secondary" variant="title" strong>
        {label}
      </Typography>
      <div className="role">
        <Typography fontColor="secondary" variant="normal">
          {description.label}
        </Typography>
        <Typography fontColor="dark" variant="normal">
          {description.desc}
        </Typography>
      </div>
      <div className="tasks">
        <Typography fontColor="secondary" variant="normal">
          {tasks.label}
        </Typography>
        <div className="task-desc">
          <Typography fontColor="dark" variant="normal">
            {tasks.task1}
          </Typography>
          <Typography fontColor="dark" variant="normal">
            {tasks.task2}
          </Typography>
          <Typography fontColor="dark" variant="normal">
            {tasks.task3}
          </Typography>
        </div>
      </div>
    </TaskCardStyled>
  );
};

export default TaskCard;
